<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索角色名稱" @search="searchEvent" :showGj="false">
				<!-- 左边 -->
				<template #left>
					<router-link :to="{name:'set_manager_rule'}" >
						<el-button class="mr-2" v-auth="'addRule'" type="primary" size="mini">添加角色</el-button>
					</router-link>

					<el-button type="danger" @click="deleteAll" v-auth="'delRule'" size="mini">批量删除</el-button>

				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">

				</el-table-column>
				<el-table-column align="center" type="index" label="排序" width="50">
				</el-table-column>
				<el-table-column align="center" prop="name" label="角色名稱">
				</el-table-column>
				<el-table-column align="center" prop="create_time" label="創建時間">
				</el-table-column>
				<el-table-column prop="id" align="center"  label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary"  v-auth="'addRule'" @click="editItem(scope.row)">编辑</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'delRule'" size="mini" plain type="danger">删除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout'],
		mixins: [common],
		data() {
			return {
				//搜索數据
				from: {
					name: '',
				},
				preUrl: "user/ruleList", //列表地址
				delAllUrl: "user/delRuleAll", //批量删除地址
				delUrl: "user/delRule", //删除單条地址
				tableData: [],
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {

		},
		methods: {
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: ''
				}
				this.$refs.buttonSearch[this.tabIndex].closeSuperSearch()
			},
		}
	}
</script>

<style>
</style>
